// All languages object
export const LANGUAGE = {
    ENGLISH: "en",
    GERMAN: "de",
};

// All country object
export const COUNTRY = {
    INDIA: "in",
    GERMANY: "de",
};

// LANGUAGE + COUNTRY CONSTANT
export const LANGUAGE_COUNTRY = {
    /** {@link COUNTRY.INDIA} **/
    EN_IN: `${LANGUAGE.ENGLISH}-${COUNTRY.INDIA}`,
    /** {@link COUNTRY.US} **/

    /** {@link COUNTRY.GERMANY} **/
    EN_DE: `${LANGUAGE.ENGLISH}-${COUNTRY.GERMANY}`,
    DE_DE: `${LANGUAGE.GERMAN}-${COUNTRY.GERMANY}`,
};

// ALL LANGUAGE + COUNTRY ARRAY
export const allLocales: string[] = Object.values(LANGUAGE_COUNTRY);
export const localeArrayMinLanguage = [LANGUAGE_COUNTRY.EN_IN];

const getCountryLocales = (country: string): Array<string> => {
    return allLocales.filter((item) => item.includes(country));
};

// ALL INDIAN LANGUAGES ARRAY
export const INDIA_LOCALES = getCountryLocales(COUNTRY.INDIA);
export const GERMANY_LOCALES = getCountryLocales(COUNTRY.GERMANY);

export const languageTextMapping = new Map<string, string>([
    [LANGUAGE.ENGLISH, "ENGLISH"],
    [LANGUAGE.GERMAN, "DEUTSCH"],
]);

export const countryTextMapping = new Map<string, string>([
    [COUNTRY.INDIA, "INDIA"],
    [COUNTRY.GERMANY, "GERMANY"],
]);
